import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core";
import Navigation from "../navigation/navigation";
import { SUBSCRIPTION_ACTION_TYPES } from "../redux-saga/actionTypes/index";
import styles from "./styles";
import { ThemeProvider } from "@material-ui/styles";
import { createMuiTheme } from "@material-ui/core/styles";
import { blueGrey, indigo, red } from "@material-ui/core/colors";

const theme = createMuiTheme({
  spacing: 2,
  palette: {
    primary: blueGrey,
    secondary: indigo
  },
  status: {
    danger: red
  },
  typography: {
    fontSize: 12,
    htmlFontSize: 16
  }
});

class App extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  componentDidMount = () => this.props.identifyUser();

  render() {
    const { classes, identified } = this.props;
    return (
      <ThemeProvider theme={theme}>
        <React.Fragment>
          <div className={classes.navigationContainer}>
            {!identified ? <Navigation /> : null}
          </div>
        </React.Fragment>
      </ThemeProvider>
    );
  }
}

App.propTypes = {
  classes: PropTypes.object.isRequired,
  identified: PropTypes.bool.isRequired,
  identifiedHasError: PropTypes.string.isRequired,
  identifyUser: PropTypes.func.isRequired
};

const mapStateToProps = ({ up }) => ({
  identified: up.identified,
  identifiedHasError: up.error
});

const mapDispatchToProps = dispatch => ({
  identifyUser: () =>
    dispatch({ type: SUBSCRIPTION_ACTION_TYPES.USER_PROFILE.IDENTIFY_USER })
});

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(App)
);
